import { render, staticRenderFns } from "./hotProduct.vue?vue&type=template&id=50047a86&scoped=true&"
import script from "./hotProduct.vue?vue&type=script&lang=js&"
export * from "./hotProduct.vue?vue&type=script&lang=js&"
import style0 from "./hotProduct.vue?vue&type=style&index=0&id=50047a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50047a86",
  null
  
)

export default component.exports